// export const API_URL = 'http://172.22.0.91:310//api/';//  // developing /
// export const API_URL = 'http://104.218.120.125:150//api/'; // live mahmoud

 export const API_URL = 'https://suapplication.su.edu.eg:151//api/'; // live
// export const API_URL = 'http://104.218.120.125:180//api/'; // testing Abdo

//  export const API_URL = 'http://suapplication.su.edu.eg:150//api/'; // live
//export const API_URL = 'http://104.218.120.125:180//api/'; // testing Abdo


// export const API_URL = 'http://41.33.39.171:150///api/'; //live server 
// export const API_URL = 'http://localhost:27739///api/';  //local host for testing
//export const API_URL = 'http://41.33.39.171:180///api/'; //Live Testing server 
//export const API_URL = process.env.VUE_APP_API_URL; //Live Testing server 
